import { Pages } from 'modules/navigation/domain/enums/pages';
import { addPopup } from 'modules/overlay-v2/store/overlay/overlay';
import { selectPopupIsLoaded } from 'modules/overlay-v2/store/overlay/selectors';
import { selectTime } from 'modules/overlay-v2/store/time/selectors';
import useGameInfo from 'modules/overlay-v2/ui/hooks/use-game-info';
import useOverlayRouteParams from 'modules/overlay-v2/ui/hooks/use-overlay-route-params';
import usePopupMessenger from 'modules/overlay-v2/ui/hooks/use-popup-messenger';
import useTimer from 'modules/overlay-v2/ui/hooks/use-timer';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from 'store/store';
import UDButton from 'ud-ui/components/button';

interface PopupControlProps {
  isLocked?: boolean;
  boardId?: number;
  isHidePanel?: boolean;
}

function PopupControl(props: PopupControlProps) {
  const dispatch = useDispatch<AppDispatch>();
  const { isLocked, boardId, isHidePanel } = props;
  const { organizerId, deviceId, token } = useOverlayRouteParams();

  const { hasPopups, send } = usePopupMessenger();
  const popupIsLoaded = useSelector(selectPopupIsLoaded);
  const gameInfo = useGameInfo();
  const time = useSelector(selectTime);
  const { timer } = useTimer();

  const handleOpenOverlay = useCallback(() => {
    if (organizerId === undefined || deviceId === undefined || !token) return;

    const windowProps = `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, width=1200, height=800`;
    // Окно оверлея открывается для того же устройства, что и панель: матч оно возьмёт
    // из трансляции само, поэтому в ссылке остаются только табло и режим показа.
    const path = Pages.OVERLAY_V2.builders.index(String(organizerId), String(deviceId), token, {
      boardId,
      locked: isLocked,
      hidePanel: isHidePanel,
    });
    // Имя окна включает табло: у каждого табло своё окно, повторное нажатие переоткрывает его же.
    const popup = window.open(window.location.origin + path, `Overlay window ${boardId ?? 'main'}`, windowProps);
    dispatch(addPopup(popup));
  }, [boardId, deviceId, dispatch, isHidePanel, isLocked, organizerId, token]);

  const handleSync = useCallback(() => {
    if (!popupIsLoaded) return;
    send({ type: 'syncState', gameInfo, time, timer });
  }, [popupIsLoaded, send, gameInfo, time, timer]);

  useEffect(() => {
    handleSync();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [send, popupIsLoaded]);

  return (
    <div className={'flex flex-row gap-4'}>
      <UDButton onClick={handleOpenOverlay} variant={'primary'} stretch>
        Открыть окно
      </UDButton>
      <UDButton onClick={handleSync} disabled={!hasPopups || !popupIsLoaded} variant={'dark'} stretch>
        Синхронизировать окна
      </UDButton>
    </div>
  );
}

export default PopupControl;
